import { useHostedMachine } from 'src/components/hosted-machine-provider';

export default useHostedMachine;
